let cart = [];

function formatCurrency(cents) {
  return new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format((cents || 0) / 100);
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

async function loadCart() {
  const response = await fetch("/cart.js");
  cart = await response.json();
  renderCart();
}

function updateCartCount() {
  document.querySelectorAll(".cart-count").forEach((node) => {
    node.textContent = cart.item_count || 0;
  });
}

function renderCart() {
  const itemsNode = document.getElementById("cartItems");
  const totalNode = document.getElementById("cartTotal");
  if (!itemsNode || !totalNode) return;
  itemsNode.innerHTML = "";
  if (!cart.items || cart.items.length === 0) {
    itemsNode.innerHTML = `<div class="cart-empty"><strong>Tu cesta está vacía.</strong><p>Añade un producto desde el catálogo o desde la ficha para iniciar el pedido.</p></div>`;
    totalNode.textContent = formatCurrency(0);
    updateCartCount();
    return;
  }
  cart.items.forEach((item) => {
    const props = Object.entries(item.properties || {})
      .filter(([, value]) => value)
      .map(([key, value]) => `<div class="cart-item__meta">${escapeHtml(key)}: ${escapeHtml(value)}</div>`)
      .join("");
    const element = document.createElement("article");
    element.className = "cart-item";
    element.innerHTML = `
      <div class="cart-item__top">
        <div>
          <div class="cart-item__name">${escapeHtml(item.product_title)}</div>
          <div class="cart-item__meta">${item.quantity} ud · ${formatCurrency(item.final_line_price)}</div>
          ${props}
        </div>
        <button class="cart-remove" type="button" onclick="removeCartItem('${item.key}')">Eliminar</button>
      </div>
    `;
    itemsNode.appendChild(element);
  });
  totalNode.textContent = formatCurrency(cart.total_price);
  updateCartCount();
}

async function removeCartItem(key) {
  await fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  await loadCart();
}

function toggleMenu() {
  const header = document.querySelector(".site-header");
  const button = document.querySelector(".menu-toggle");
  header?.classList.toggle("is-menu-open");
  button?.setAttribute("aria-expanded", header?.classList.contains("is-menu-open") ? "true" : "false");
}

function closeMenu() {
  const header = document.querySelector(".site-header");
  const button = document.querySelector(".menu-toggle");
  header?.classList.remove("is-menu-open");
  button?.setAttribute("aria-expanded", "false");
}

function openCart() {
  loadCart();
  document.querySelector(".cart-overlay")?.classList.add("is-open");
  document.querySelector(".cart-drawer")?.classList.add("is-open");
}

function closeCart() {
  document.querySelector(".cart-overlay")?.classList.remove("is-open");
  document.querySelector(".cart-drawer")?.classList.remove("is-open");
}

function goToCheckout() {
  window.location.href = "/checkout";
}

function showCookieNoticeIfNeeded() {
  const notice = document.getElementById("cookieNotice");
  if (notice && !localStorage.getItem("pequeando_cookie_notice_v1")) {
    notice.classList.add("is-visible");
  }
}

function acceptCookieNotice() {
  localStorage.setItem("pequeando_cookie_notice_v1", "accepted");
  document.getElementById("cookieNotice")?.classList.remove("is-visible");
}

document.addEventListener("DOMContentLoaded", () => {
  loadCart();
  showCookieNoticeIfNeeded();
  document.querySelectorAll("form[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const formData = new FormData(form);
      const response = await fetch("/cart/add.js", { method: "POST", body: formData });
      if (!response.ok) {
        alert("No se ha podido añadir el producto.");
        return;
      }
      await loadCart();
      openCart();
    });
  });
});
